/* eslint-disable react/destructuring-assignment, react/prop-types */
import React, { useEffect } from 'react'
import CookiePopup from '../../cookiepopup'
import { initGTM } from '../../../utils/tagmanager'

const NftTagManager = () => {
    useEffect(() => {
        if (!window.TAGS_INITIALIZED) {
            initGTM()
            window.TAGS_INITIALIZED = true
        }
    }, [])

    return (
        <>
            <CookiePopup />
        </>
    )
}

export default NftTagManager
